import { Case, CaseInfo, NamedUser } from "generated/graphql";
import { useCaseInfoDisplayGroups } from "./useCaseInfoDisplayGroups";
import EditCaseInfoDialog from "./EditCaseInfoDialog";
import { useAppSelector } from "redux/hooks";
import { selectCaseCalcs } from "redux/slices/case";

export default function CaseEditInfoDialogWrapper({
  ccase,
  open,
  onClose,
  caseAssignees,
  edited,
}: {
  ccase: Case;
  open: boolean;
  onClose: () => void;
  caseAssignees: NamedUser[];
  edited?: (info: CaseInfo, userAssignee?: NamedUser) => void;
}) {
  const calcs = useAppSelector(selectCaseCalcs);
  const caseInfoDisplayGroups = useCaseInfoDisplayGroups(ccase, calcs);
  const defaultGroup = caseInfoDisplayGroups.defaultGroup;

  return defaultGroup !== undefined ? (
    <EditCaseInfoDialog
      open={open}
      close={onClose}
      mycase={ccase}
      edited={edited}
      assignees={caseAssignees}
      caseProperties={defaultGroup.propertyValues.map((pv) => pv.caseProperty)}
      canEditCaseInfo
    />
  ) : (
    <></>
  );
}
